import contactDirectoryData from './contactDirectoryData.json';

export const { markets, brokers } = contactDirectoryData;

const MARKET_BY_NAME = new Map(markets.map((m) => [m.marketName, m.marketNumber]));
const BROKER_NAME_SET = new Set(brokers);

export const UPLOAD_TYPES = {
  SUPPLIER_SUPPLIER_CONTACT: {
    label: 'Supplier - Supplier Contact',
    callerRole: 'SUPPLIER',
    columns: ['vendor_number', 'market_name', 'market_number', 'primary_contact_name', 'primary_contact_email', 'primary_contact_phone'],
    columnLabels: ['Vendor Number', 'Market Name', 'Market Number', 'Primary Contact Name', 'Primary Contact Email', 'Primary Contact Phone'],
    lockedColumns: ['market_name', 'market_number'],
    requiredColumns: ['vendor_number', 'primary_contact_name', 'primary_contact_email', 'primary_contact_phone'],
    naturalKey: ['vendor_number', 'market_number'],
    templateUrl: '/contact-directory-templates/supplier-supplier-contact-upload-template.xlsx',
  },
  SUPPLIER_BROKER_CONTACT: {
    label: 'Supplier - Broker Contact',
    callerRole: 'SUPPLIER',
    columns: ['vendor_number', 'market_name', 'market_number', 'broker_name'],
    columnLabels: ['Vendor Number', 'Market Name', 'Market Number', 'Broker Name'],
    lockedColumns: ['market_name', 'market_number'],
    requiredColumns: ['vendor_number', 'broker_name'],
    naturalKey: ['vendor_number', 'market_number'],
    templateUrl: '/contact-directory-templates/supplier-broker-contact-upload-template.xlsx',
  },
  BROKER_BROKER_CONTACT: {
    label: 'Broker - Broker Contact',
    callerRole: 'BROKER',
    columns: ['market_name', 'market_number', 'primary_contact_name', 'primary_contact_email', 'primary_contact_phone'],
    columnLabels: ['Market Name', 'Market Number', 'Primary Contact Name', 'Primary Contact Email', 'Primary Contact Phone'],
    lockedColumns: ['market_name', 'market_number'],
    requiredColumns: ['primary_contact_name', 'primary_contact_email', 'primary_contact_phone'],
    naturalKey: ['broker_name', 'market_number'],
    metadataFields: ['broker_name'],
    templateUrl: '/contact-directory-templates/broker-broker-contact-upload-template.xlsx',
  },
};

export function normalizeHeader(header) {
  return String(header || '').trim().toLowerCase().replace(/\s+/g, '_');
}

export function isKnownMarketPair(marketName, marketNumber) {
  return MARKET_BY_NAME.get(marketName) === Number(marketNumber);
}

export function isKnownBrokerName(brokerName) {
  return BROKER_NAME_SET.has(brokerName);
}
